var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-nav-item",class:_vm.cssClassesNav},[_c('div',{staticClass:"v-nav-item-title",on:{"click":function($event){return _vm.toggle()}}},[_vm._t("default"),(_vm.hasDropdown)?_c('v-icon',{attrs:{"icon":"chevron-down","ratio":0.4}}):_vm._e()],2),_c('transition',{attrs:{"name":"toggle-dropdown"}},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }